import { Tour } from "@/components/guided-tour/tour";

export const TOURS: Record<string, Tour> = {
  "/dashboard": {
    id: "v1-dashboard",
    steps: [
      {
        id: "welcome",
        title: "Welcome to Digital Domination",
        body: "This dashboard is your control center. Each card surfaces one signal you can act on right now.",
        placement: "center",
      },
      {
        id: "sidebar",
        target: "[data-testid='link-gbp-optimization'], a[href='/gbp-optimization']",
        title: "Your tools live in the sidebar",
        body: "Each link is a step in the local SEO playbook — start at the top and work your way down.",
        placement: "right",
      },
    ],
  },
  "/gbp-optimization": {
    id: "v1-gbp-optimization",
    steps: [
      {
        id: "intro",
        title: "Optimize your Google Business Profile",
        body: "Three guided steps. Each one runs a quick scan, shows what to change, and lets you approve before anything goes live.",
        placement: "center",
      },
      {
        id: "step1",
        target: "[data-testid='card-step1-category'], [data-testid='card-step1-locked']",
        title: "Step 1 — Category match",
        body: "We compare your current GBP category against what your competitors use. Approve the recommendation to update Google.",
        placement: "bottom",
      },
      {
        id: "step2",
        target: "[data-testid='card-step2-keywords'], [data-testid='card-step2-locked']",
        title: "Step 2 — Tracked keywords",
        body: "Pick the search terms you want to rank for. These power the rest of the optimization.",
        placement: "bottom",
      },
      {
        id: "step3",
        target: "[data-testid='card-step3-services'], [data-testid='card-step3-locked']",
        title: "Step 3 — Service descriptions",
        body: "We generate keyword-rich service entries tied to landmarks across your service area. Edit, exclude, or push them straight to your profile.",
        placement: "top",
      },
    ],
  },
  "/geogrid": {
    id: "v1-geogrid",
    steps: [
      {
        id: "intro",
        title: "GeoGrid — your visibility map",
        body: "Each grid point is a search location. Color shows how high you rank when someone searches there.",
        placement: "center",
      },
    ],
  },
  "/reviews": {
    id: "v1-reviews",
    steps: [
      {
        id: "intro",
        title: "Reviews",
        body: "All your Google reviews in one place. Use the AI reply to draft fast, on-brand responses.",
        placement: "center",
      },
    ],
  },
  "/posts": {
    id: "v1-posts",
    steps: [
      {
        id: "intro",
        title: "Posts",
        body: "Schedule keyword-targeted GBP posts. Consistent posting tells Google your profile is active.",
        placement: "center",
      },
    ],
  },
  "/profile-health": {
    id: "v1-profile-health",
    steps: [
      {
        id: "intro",
        title: "Profile Essentials",
        body: "A scorecard of every GBP field that affects ranking. Anything red is a quick win.",
        placement: "center",
      },
    ],
  },
  "/citations": {
    id: "v1-citations",
    steps: [
      {
        id: "intro",
        title: "Citations",
        body: "Make sure your business name, address, and phone match across the web. Mismatches hurt local rankings.",
        placement: "center",
      },
    ],
  },
  "/products": {
    id: "v1-products",
    steps: [
      {
        id: "intro",
        title: "Product Forge",
        body: "Generate optimized product entries for your GBP profile. Each product is another way to surface for searches.",
        placement: "center",
      },
    ],
  },
  "/reports": {
    id: "v1-reports",
    steps: [
      {
        id: "intro",
        title: "Client Reports",
        body: "Every week we compile a snapshot of ranking changes, reviews, and growth. Share or export.",
        placement: "center",
      },
    ],
  },
  "/road-to-domination": {
    id: "v1-road-to-domination",
    steps: [
      {
        id: "intro",
        title: "Road to Domination",
        body: "Your full journey from setup to top-3 rankings. Check items off as you complete them.",
        placement: "center",
      },
    ],
  },
};
